module.exports = __webpack_public_path__ + "static/media/rainy.88e8e798.svg";